module.exports = __webpack_public_path__ + "static/media/p_54_2.d91e8d81.png";